/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  MasterZoneModulePermissionTreeRestService,
  MasterZoneRestService,
  OfficeRestService,
} from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { MasterZone } from './master-zone.model';
import { MasterZoneModulePermissionTree } from './office-module-permission-tree.model';

@Injectable()
export class OfficeModulePermissionDetailsBusinessService implements InitViewService {

  constructor(private masterZoneRest: MasterZoneRestService,
              private officeRest: OfficeRestService,
              private dictionaryService: DictionaryService,
              private masterZoneModulePermissionTreeRest: MasterZoneModulePermissionTreeRestService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    const masterId = route.params['masterZoneId'];

    return {
      masterZone: this.getMasterZone(masterId),
      permissionTree: this.getModulePermissions(masterId),
    };
  }

  getMasterZone(id: ID): Observable<MasterZone> {
    return this.masterZoneRest.get(id);
  }

  getModulePermissions(masterZoneId: ID): Observable<MasterZoneModulePermissionTree> {
    return this.masterZoneModulePermissionTreeRest.get(masterZoneId);
  }

  updateModulePermissions(tree: MasterZoneModulePermissionTree): Observable<MasterZoneModulePermissionTree> {
    return this.masterZoneModulePermissionTreeRest.update(tree);
  }
}
